import NewJobOpeningCard from "./newJobOpeningCard";
export default NewJobOpeningCard;